var map = {
	"./Badschrank_1.jpg": 8337,
	"./Badschrank_1_lowres.jpg": 5302,
	"./Badschrank_1_small.jpg": 7347,
	"./Badschrank_2.jpg": 1697,
	"./Badschrank_2_lowres.jpg": 6438,
	"./Badschrank_2_small.jpg": 7362,
	"./Badschrank_3.jpg": 9023,
	"./Badschrank_3_lowres.jpg": 721,
	"./Badschrank_3_small.jpg": 3606,
	"./Bett_1.jpg": 4425,
	"./Bett_1_lowres.jpg": 1500,
	"./Bett_1_small.jpg": 3674,
	"./Bett_2.jpg": 478,
	"./Bett_2_lowres.jpg": 5643,
	"./Bett_2_small.jpg": 5066,
	"./Buffet_1.jpg": 8392,
	"./Buffet_1_lowres.jpg": 7380,
	"./Buffet_1_small.jpg": 1918,
	"./Buffet_2.jpg": 95,
	"./Buffet_2_lowres.jpg": 4274,
	"./Buffet_2_small.jpg": 8796,
	"./Couchtisch_1.jpg": 3538,
	"./Couchtisch_1_lowres.jpg": 3397,
	"./Couchtisch_1_small.jpg": 9934,
	"./Couchtisch_2.jpg": 5764,
	"./Couchtisch_2_lowres.jpg": 1388,
	"./Couchtisch_2_small.jpg": 3382,
	"./Logo_weiss_m2.jpg": 3714,
	"./Matthias-2.jpg": 6569,
	"./Matthias-2_lowres.jpg": 8094,
	"./Matthias.jpg": 827,
	"./Matthias_1.jpg": 623,
	"./Matthias_1_lowres.jpg": 7225,
	"./Matthias_1_small.jpg": 3639,
	"./Matthias_2.jpg": 3698,
	"./Matthias_2_lowres.jpg": 7276,
	"./Matthias_2_small.jpg": 2331,
	"./Matthias_3.jpg": 3932,
	"./Matthias_3_lowres.jpg": 76,
	"./Matthias_3_small.jpg": 5984,
	"./Matthias_about.jpg": 2402,
	"./Matthias_about_lowres.jpg": 4068,
	"./Meister_1.jpg": 1499,
	"./Meister_1_lowres.jpg": 5913,
	"./Meister_1_small.jpg": 3268,
	"./Meister_2.jpg": 7553,
	"./Meister_2_lowres.jpg": 4288,
	"./Meister_2_small.jpg": 9979,
	"./Mika-lowres.jpg": 262,
	"./Mika.jpg": 2212,
	"./Mika_about.jpg": 935,
	"./Mika_about_lowres.jpg": 7987,
	"./Nachttisch_1.jpg": 9916,
	"./Nachttisch_1_lowres.jpg": 9379,
	"./Nachttisch_1_small.jpg": 5684,
	"./Nachttisch_2.jpg": 5406,
	"./Nachttisch_2_lowres.jpg": 6918,
	"./Nachttisch_2_small.jpg": 9138,
	"./Sideboard_1.jpg": 6336,
	"./Sideboard_1_lowres.jpg": 697,
	"./Sideboard_1_small.jpg": 3871,
	"./Sideboard_2.jpg": 5987,
	"./Sideboard_2_lowres.jpg": 2420,
	"./Sideboard_2_small.jpg": 9856,
	"./Sideboard_3.jpg": 1930,
	"./Sideboard_3_lowres.jpg": 9802,
	"./Sideboard_3_small.jpg": 269,
	"./Tisch_1.jpg": 7366,
	"./Tisch_1_lowres.jpg": 5646,
	"./Tisch_1_small.jpg": 7024,
	"./Tisch_2.jpg": 6519,
	"./Tisch_2_lowres.jpg": 4837,
	"./Tisch_2_small.jpg": 8933,
	"./Tisch_3.jpg": 5333,
	"./Tisch_3_lowres.jpg": 7316,
	"./Tisch_3_small.jpg": 2182,
	"./Tisch_4.jpg": 7413,
	"./Tisch_4_lowres.jpg": 5192,
	"./Tisch_5.jpg": 8109,
	"./Tisch_5_lowres.jpg": 9213,
	"./Tisch_5_small.jpg": 7964,
	"./Tisch_6.jpg": 1424,
	"./Tisch_6_lowres.jpg": 189,
	"./Tisch_6_small.jpg": 9093,
	"./card.jpg": 7414,
	"./group_2.jpg": 7664,
	"./group_2_lowres.jpg": 8482,
	"./home_both.jpg": 7629,
	"./home_both_lowres.jpg": 6631,
	"./home_both_small.jpg": 1345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;